import {pageInfo, exportData, addData, deleteData, initEdit, editData, importData, downloadTemplate} from './../api';
import { Message } from 'element-ui';
import { companyListData } from "../../company/api/index"
import {listShipType, getEntity} from "../../../../api";
const shipper = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null,
    deleteDataObj: null,
    addDataObj: null,
    initEditObj: null,
    editDataObj: null,
    downloadTemplateObj: null,
    importDataObj: null,
    shipTypeObj: null,
    companyObj: null,
    entityObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    ADD_DATA(state, data) {
      state.addDataObj = data;
    },
    DELETE_DATA(state, data) {
      state.deleteDataObj = data;
    },
    INIT_EDIT(state, data) {
      state.initEditObj = data;
    },
    EDIT_DATA(state, data) {
      state.editDataObj = data;
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    LIST_SHIP_TYPE(state, data) {
      state.shipTypeObj = data.obj;
    },
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj;
    },
    LIST_ENTITY(state, data) {
      state.entityObj = data.obj;
    },
  },
  actions: {
    //查询
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出文件
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //添加删除
    async addData({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //删除数据
    async deleteData({ commit }, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //修改数据
    async initEdit({ commit }, obj) {
      let resp = await initEdit(obj);
      commit('INIT_EDIT', resp);
    },
    //修改数据
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //下载模板
    async downloadTemplate({ commit }, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //导入数据
    async importData({ commit }, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },

    //运输类型
    async listShipType({ commit }, obj) {
      let resp = await listShipType(obj);
      commit('LIST_SHIP_TYPE', resp);
    },
    /**
     * 机构查询
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async listCompany({ commit }, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
    /**
     * 企业主体信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getEntity({ commit }, obj) {
      let resp = await getEntity(obj);
      commit('LIST_ENTITY', resp);
    },
  }
}
export default shipper



// WEBPACK FOOTER //
// ./src/page/mdm/shipper/store/shipper.store.js